import { EMPTY_STRING } from '../../../../../constants/common'
import { LISTING_VIEWING_ROW_ACTIONS } from '../../../../RentalPortalViewing'

export function getIsListingViewingsEmpty({ hasError, isInitiated, items }) {
  const isLoaded = isInitiated && !hasError

  return isLoaded && items.length === 0
}

export function getListingViewingApplicantLabel(viewing) {
  return viewing?.applicant?.label ?? EMPTY_STRING
}

export function getListingViewingItemActions() {
  return LISTING_VIEWING_ROW_ACTIONS
}
